<template>
  <div id="deliveryDate">
    <div class="form" :class="[$mq, {TA:isTestAchat}]">
      <h1>{{ title }}</h1>
      <BecomeField
        name="deliveryDate"
        type="calendar"
        :defaultDate="defaultDate"
        :calendarRules="deliveryDateRule"
        :value="defaultDate | moment('DD/MM/YYYY')"
        @input="changeDate($event)"
        required
      ></BecomeField>
    </div>
  </div>
</template>

<script>
import BecomeField from '@/components/Form/BecomeField'
import { mapGetters, mapState } from 'vuex';
import dateRules from '@/validations/dateRules';

export default {
  computed: {
    ...mapState("contract", ["scenario"]),
    ...mapGetters("contract", ["isElectricityMeterOpen", "isGasMeterOpen"]),
    ...mapGetters("subscription", ["isTestAchat"]),
    title() {
      return this.scenario === 'move' ? this.$t('Contract.OpenDate.title') : this.$t('Contract.DeliveryDate.title')
    },
    electricityDeliveryDate: {
      get() {
        return this.$store.getters["contract/electricityDeliveryDate"];
      },
      set(value) {
        this.$store.commit("contract/setElectricityDeliveryDate", value);
      }
    },
    electricityOpenMeterDate: {
      get() {
        return this.$store.getters["contract/electricityOpenMeterDate"];
      },
      set(value) {
        this.$store.commit("contract/setElectricityOpenMeterDate", value);
      }
    },
    gasDeliveryDate: {
      get() {
        return this.$store.getters["contract/gasDeliveryDate"];
      },
      set(value) {
        this.$store.commit("contract/setGasDeliveryDate", value);
      }
    },
    gasOpenMeterDate: {
      get() {
        return this.$store.getters["contract/gasOpenMeterDate"];
      },
      set(value) {
        this.$store.commit("contract/setGasOpenMeterDate", value);
      }
    },
    defaultDate() { 
      return this.scenario === 'move' ? this.$moment(this.electricityOpenMeterDate || this.gasOpenMeterDate, 'DD/MM/YYYY').toDate() : this.$moment(this.electricityDeliveryDate || this.gasDeliveryDate, 'DD/MM/YYYY').toDate();
    }
  },
  methods: {
    deliveryDateRule(date) {
      return !dateRules.deliveryDate(date);
    },
    changeDate(value) {
      if(value) {
        if(this.scenario === 'move') {
          if(this.electricityOpenMeterDate)
            this.electricityOpenMeterDate = this.$moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
  
          if(this.gasOpenMeterDate)
            this.gasOpenMeterDate = this.$moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
        } else {
          if(this.electricityDeliveryDate)
            this.electricityDeliveryDate = this.$moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
  
          if(this.gasDeliveryDate)
            this.gasDeliveryDate = this.$moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
        }

        this.$emit('close')
      }
    }
  },
  components: {
    BecomeField,
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/DeliveryDate.vue